import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

// PrimeNG Modules
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { CalendarModule } from 'primeng/calendar';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';

// Shared Module
import { SharedModule } from '../../shared/shared.module';
import { ActionTooltipModule } from '../../shared/directives/action-tooltip.module';

// Components
import { EntitiesGridComponent } from './entities-grid.component';
import { EntityDetailComponent } from './entity-detail/entity-detail.component';
import { EntityFormComponent } from './entity-form/entity-form.component';

// Services
import { EntitiesService } from './entities.service';
import { MessageService } from 'primeng/api';

@NgModule({
  declarations: [
    EntitiesGridComponent,
    EntityDetailComponent,
    EntityFormComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    TableModule,
    ButtonModule,
    DialogModule,
    DropdownModule,
    InputTextModule,
    CalendarModule,
    MessageModule,
    MessagesModule,
    ToastModule,
    TooltipModule,
    ActionTooltipModule
  ],
  providers: [
    EntitiesService,
    MessageService
  ],
  exports: [
    EntitiesGridComponent,
    EntityDetailComponent,
    EntityFormComponent
  ]
})
export class EntitiesModule { }